import styled from 'styled-components';

export const Container = styled.div`
  @media (min-width: ${({ theme }) => theme.mediaQueries.sm}) {
    width: 75%;
  }
`;
